import React from "react";
//import PropTypes from 'prop-types';

import Resources from "playground/cms/views/Resources";
import { FormLayout } from "playground/cms/Form";
import SyncTasksForm from "./SyncTasksForm";
import { CronManager } from "./Cron";

export function renderForm(props) {
    return (
        <FormLayout>
            <FormLayout.Content replace={true}>
                <FormLayout.Tab
                    id={"sync-task"}
                    label={"Ustawienia synchronizacji"}
                >
                    <SyncTasksForm {...props} />
                </FormLayout.Tab>
                <FormLayout.Tab id={"cron"} label={"Harmonogram"}>
                    <FormLayout.Fieldset pad>
                        <CronManager />
                    </FormLayout.Fieldset>
                </FormLayout.Tab>
            </FormLayout.Content>
        </FormLayout>
    );
}

export function SyncTasks(props) {
    const {} = props;
    return <Resources {...props}>{renderForm(props)}</Resources>;
}

SyncTasks.propTypes = {};

SyncTasks.defaultProps = {};

export default SyncTasks;
